import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ensureCsrfToken, getUser } from "../utils/api";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        await ensureCsrfToken();
        const userData = await getUser();
        if (isMounted) setUser(userData);
      } catch (err) {
        if (isMounted) setUser(null);
      } finally {
        if (isMounted) setLoading(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#f9fafb",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <CircularProgress size={60} thickness={5} />
        <Box sx={{ fontSize: 14, color: "#555" }}>Checking your account...</Box>
      </Box>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Not authorized
  if (allowedRoles.length && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />; // or a 403 page
  }

  return children;
}